import React from 'react';
import AddressName from '../Components/AddressName';
import { connect } from 'react-redux';
import NumberFormatter from './NumberFormatter';

const mapStateToProps = state => {
  return {
    currentAccount: state.account.currentAccount,
    asyncCoinBalance: state.account.asyncCoinBalance,
    ethereumBalance: state.account.ethereumBalance
  };
};

const ConnectedNavigationInformation = ({currentAccount, asyncCoinBalance, ethereumBalance}) => (
  <div className="c-navigation__info">
    <div><AddressName address={currentAccount}/></div>
    <div><strong><NumberFormatter number={asyncCoinBalance || 0}/> ASC</strong></div>
    <div><strong><NumberFormatter number={ethereumBalance || 0}/> ETH</strong></div>
  </div>
);

const NavigationInformation = connect(mapStateToProps)(ConnectedNavigationInformation);

export default NavigationInformation;



// WEBPACK FOOTER //
// ./src/components/Components/NavigationInformation.js